<template>
  
  <div class="snapshot-table">

    <div style="width: 100%; text-align: center" class="my-4">
      <button @click="filterUpdateVue()" class="btn sm">Update</button>
    </div>

    <vue-good-table
      ref="table"
      :columns="columns"
      :rows="orders"
      :search-options="{
        enabled: true,
        trigger: 'enter',
        skipDiacritics: true,
        placeholder: 'Search this table',
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'id', type: 'desc'}
      }"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 40,
      }"
      @on-row-click="onRowClick"
    >
      <div slot="table-actions">
        <button @click="exportXLSX()" class="export">
          <svg viewBox="0 0 384 512"><path d="M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM64 208v224c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16zm224 208h-80v-48h80v48zm0-80h-80v-48h80v48zM96 224h192v32H96v-32zm0 64h80v48H96v-48zm0 80h80v48H96v-48z"/></svg>
        </button>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import { jsonToExcel, formatSnapshot, getAllocatedOrdersColumns } from '../jsonToExcel';

export default {
  name: 'Snapshot-Orders',
  props: {
    orders: Array,
    products: Array,
    path: {
      required: false,
      type: String,
      default: '/vendors/allocated/allocatedOrder'
    }
  },
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Customer Name',
          field: 'accountName'
        },
        {
          label: 'Allocated ID',
          field: 'id',
          type: 'number',
          sortable: true,
          firstSortType: 'desc',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
          },
        },
        {
          label: 'Allocation Status',
          field: 'allocatedOrderStatus'
        },
/*        
        {
          label: 'Product Name',
          field: 'productName',
        },
        {
          label: 'Qty',
          field: 'productQty',
          type: 'number',
        },
*/        
        {
          label: 'Product Type',
          field: 'productTypeName'
        },
        {
          label: 'Est Ship Date',
          field: 'anticipatedPickupDate',
          type: 'date',
          dateInputFormat: 'MM/dd/yyyy',
          dateOutputFormat: 'MM/dd/yyyy'
        },
        {
          label: 'Actual Ship Date',
          field: 'pickupDate',
          type: 'date',
          dateInputFormat: 'MM/dd/yyyy',
          dateOutputFormat: 'MM/dd/yyyy'
        },
        {
          label: 'Est Arrival Date',
          field: 'anticipatedDeliveryDate',
          type: 'date',
          dateInputFormat: 'MM/dd/yyyy',
          dateOutputFormat: 'MM/dd/yyyy'
        },  
        {
          label: 'Actual Arrival Date',
          field: 'deliveryDate',
          type: 'date',
          dateInputFormat: 'MM/dd/yyyy',
          dateOutputFormat: 'MM/dd/yyyy'
        },      
        {
          label: 'Delivery Tracking Code',
          field: 'deliveryTrackingCode'
        },
        {
          label: 'CHR Tracking',
          field: 'chr',
        },
        {
          label: 'PO Needed?',
          field: 'poRequired'
        },
        {
          label: 'PO Number',
          field: 'poNum',
        },
      ]
    }
  },
  methods: {
    exportXLSX() {
      let results = this.$refs.table.filteredRows[0].children

      if (results.length === 0 ) {
        results = this.orders;
      }

      let rows = formatSnapshot(results);
      let exportColumns = getAllocatedOrdersColumns(results, this.products);

      let filterValue = document.querySelector("#orderFilter");
      let value = filterValue.options[filterValue.selectedIndex].text.toLowerCase();
      let type = "";
      if (value != "none") 
        type = value + '-';

      jsonToExcel(rows, exportColumns, "Snapshot", `${type}snapshot-${new Date().toISOString()}.xlsx`);
    },
    onRowClick (params) {
      const order = params.row
      window.location.href = `${this.path}/?id=${order.id}&orderId=${order.orderId}`;
    },
    itemsBtn () {
      return '<button class="rounded-full flex items-center text-base text-white shadow-solid bg-green py-2 px-4">Review</button>'
    },
    filterUpdateVue() {
      var dateRange = "30";
      var dateElements = document.getElementsByName("dateRange");
      for (var i = 0; i < dateElements.length; i++) {
        if (dateElements[i].checked) {
            dateRange = dateElements[i].value;
        }
      }

      var orderFilter = document.getElementById("orderFilter").value;

      var reportUser =  document.getElementById("customers").value;

      window.location.replace('/rd/snapshot?d=' + dateRange + '&user=' + reportUser.toString() + '&of=' + orderFilter.toString())
      
    }

  }
}
</script>